import { render, staticRenderFns } from "./image-fileTypes-editor.vue?vue&type=template&id=56e2d75a&scoped=true"
import script from "./image-fileTypes-editor.vue?vue&type=script&lang=js"
export * from "./image-fileTypes-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e2d75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e2d75a')) {
      api.createRecord('56e2d75a', component.options)
    } else {
      api.reload('56e2d75a', component.options)
    }
    module.hot.accept("./image-fileTypes-editor.vue?vue&type=template&id=56e2d75a&scoped=true", function () {
      api.rerender('56e2d75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-image/image-fileTypes-editor.vue"
export default component.exports